import { DayOfWeek } from '@/util/types/day-of-week';
import { DayOfWeekIndex } from '@/util/enums/day-of-week-index';

export const DAY_OF_WEEK_MAP: ReadonlyMap<DayOfWeekIndex, DayOfWeek> = new Map<DayOfWeekIndex, Readonly<DayOfWeek>>([
	[
		DayOfWeekIndex.SUNDAY,
		{
			code: 'SU',
			full: 'Sunday',
			num: DayOfWeekIndex.SUNDAY,
		},
	],
	[
		DayOfWeekIndex.MONDAY,
		{
			code: 'MO',
			full: 'Monday',
			num: DayOfWeekIndex.MONDAY,
		},
	],
	[
		DayOfWeekIndex.TUESDAY,
		{
			code: 'TU',
			full: 'Tuesday',
			num: DayOfWeekIndex.TUESDAY,
		},
	],
	[
		DayOfWeekIndex.WEDNESDAY,
		{
			code: 'WE',
			full: 'Wednesday',
			num: DayOfWeekIndex.WEDNESDAY,
		},
	],
	[
		DayOfWeekIndex.THURSDAY,
		{
			code: 'TH',
			full: 'Thursday',
			num: DayOfWeekIndex.THURSDAY,
		},
	],
	[
		DayOfWeekIndex.FRIDAY,
		{
			code: 'FR',
			full: 'Friday',
			num: DayOfWeekIndex.FRIDAY,
		},
	],
	[
		DayOfWeekIndex.SATURDAY,
		{
			code: 'SA',
			full: 'Saturday',
			num: DayOfWeekIndex.SATURDAY,
		},
	],
]);
